import axios from '@/mod/axiosMod';
import URL from '../util/url';

export default {
  /**
   * 获取钱包信息，用来跳转到钱包页面
   * @param poiId 门店ID
   * @returns {*}
   */
  getWalletInfo(poiId) {
    return axios.post('/api/cdb/wallet/info/v1', { poiId });
  },

  /**
   * 是否可以开通钱包
   * @param
   * @returns {*}
   */
  checkIsCanCreateWallet() {
    return axios.get('/apigw/api/kdb/merchant-verify-status');
  },
  /**
   * 获取钱包首页
   */
  getHomePageUrl(poiId) {
    const source = URL.isWXApplet ? 65 : 27;
    return axios.post('/api/bill/v2/finance-url', { source, poiId });
  },
};
